import { Component, Input } from '@angular/core';
import { PlayerStatisticsPerformanceModel } from 'models/statistics';

@Component({
    selector: 'app-player-performance',
    templateUrl: './player-performance.component.html',
    styleUrls: ['./player-performance.component.scss'],
    imports: [],
})
export class PlayerPerformanceComponent {
    @Input()
    public performance: Array<PlayerStatisticsPerformanceModel> = [];
}
